import React from 'react';
import Button from "../button";
import CustomSelect from "../General/customSelect";
import FormGroupSelectInput from "../formGroupSelectInput";
import {CUSTOM_AUTOSUGGEST_INPUT_STYLE, TABLE_VIEW_OPTIONS} from "../../helpers/variables";
import {Link} from "react-router-dom";
import CircleIcon from "../icons/circleIcon";
import CustomCheckbox from "../General/customCheckbox";
import Pagination from "../pagination";
import Autosuggest from "react-autosuggest";
import OverlayIndicator from "../General/overlayIndicator";
import SearchIcon from "../icons/searchIcon";
import AgentsListSortElement from "../AgentsList/agentsListSortElement";

const actionsMenuOptions = [
    {key: '', value: 'Select an action'},
    {key: 'enable', value: 'Enable'},
    {key: 'disable', value: 'Disable'}
];

const url = '/brokers/edit-broker/';

const Brokers = (props) => {
    const { tableColumns, brokers, _isRowChecked, _handleRowSelect, viewAmount, changeBrokersState, action,
        brokersListPageShift, totalPaginationBoxes, page, totalRecords, changeBrokersListPage, loading,
        applyAction, autoSuggestInputProps, onSuggestionsFetchRequested, onSuggestionsClearRequested,
        getSuggestionValue, renderSuggestion, onSuggestionSelected, suggestions, brokerFirms, filterByBroker,
        submitListFilters, sortBy, sortOrder, sortBrokers, _handleAutoSuggestIconClick} = props;
    const brokerFirmsOptions = brokerFirms.map(brokerFirm => ({key: brokerFirm.id, value: brokerFirm.name}));
    brokerFirmsOptions.unshift({key: '', value: ''});
    return (
        <div className={'mb-15'}>
            <div className={'row'}>
                <h2 className="col-sm-12 applicationsAndPolicies-h2">Broker Users (BTE)</h2>
            </div>
            <div className={'row'}>
                <div className={'col-sm-12 mb-15'}>
                    <Button
                        clickHandler={()=>props.history.push('/brokers/add-broker')}
                        wrapper="btn-wrapper"
                        btnType="button"
                        btnStyle={'btn btn-primary btn-xs sharp yellow'}
                        label="Create Broker User"/>
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-sm-12'}>
                    <form className={'form-horizontal'} onSubmit={submitListFilters}>
                        <FormGroupSelectInput
                            Value={filterByBroker}
                            Label='Filter by Broker'
                            LeftWrapper="col-sm-2"
                            Options={brokerFirmsOptions}
                            HandleInputChange={evt => changeBrokersState({
                                key:'filterByBroker',
                                value: evt.target.value
                            })}
                            CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                            SelectStyle={'form-control formGroupSelectInput-select'}
                        />
                        <div className={'form-group'}>
                            <div className={'col-sm-2'}>
                                <FormGroupSelectInput
                                    Value={viewAmount}
                                    Label='View'
                                    LeftWrapper="col-sm-5"
                                    Options={TABLE_VIEW_OPTIONS}
                                    HandleInputChange={evt => changeBrokersState({
                                        key:'viewAmount',
                                        value: evt.target.value
                                    })}
                                    CenterWrapper="col-sm-7 formGroupSelectInput-select-wrapper"
                                    RightWrapper=""
                                    SelectStyle={'form-control formGroupSelectInput-select'}
                                />
                            </div>
                            <div className={'col-sm-6'} onKeyPress={evt => {
                                if(evt.key === 'Enter'){ _handleAutoSuggestIconClick()}
                            }}>
                                <Autosuggest
                                    suggestions={suggestions}
                                    onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                                    onSuggestionsClearRequested={onSuggestionsClearRequested}
                                    getSuggestionValue={getSuggestionValue}
                                    renderSuggestion={renderSuggestion}
                                    inputProps={autoSuggestInputProps}
                                    onSuggestionSelected={onSuggestionSelected}
                                    theme={CUSTOM_AUTOSUGGEST_INPUT_STYLE}
                                />
                                <div className="applicationsAndPolicies-autosuggest-search-icon"
                                     onClick={_handleAutoSuggestIconClick}
                                >
                                    <SearchIcon/>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <hr className="appFormRefSettings-hr" style={{marginTop: '0'}}/>
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-sm-3 mb-15'}>
                    <CustomSelect
                        name={'action'}
                        onChange={(evt)=> changeBrokersState({
                            key:'action',
                            value: evt.target.value
                        })}
                        value={action}
                        options={actionsMenuOptions}
                    />
                </div>
                <div className={'col-sm-9 mb-15'}>
                    <Button
                        clickHandler={applyAction}
                        wrapper="btn-wrapper"
                        btnType="button"
                        btnStyle={'btn btn-primary btn-xs sharp yellow'}
                        label="Apply"/>
                </div>
            </div>
            <div className={'row'}>
                <div className={'col-sm-12 table-wrapper__arag'}>
                    <table className={'table'}>
                        <caption style={{padding: '0px'}}>
                            <OverlayIndicator fetching={loading}/>
                        </caption>
                        <thead>
                        <tr>
                            {tableColumns.map((column, index) => (
                                <th key={index}>
                                    {column.name}
                                    {column.sortable && (
                                        <AgentsListSortElement
                                            sortBy={sortBy}
                                            sortOrder={sortOrder}
                                            sortAgentsList={sortBrokers}
                                            columnName={column.key}
                                        />
                                    )}
                                </th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        {brokers.map((broker, index) => (
                            <tr key={index} className={'table-link-row'}>
                                <td>
                                    <CustomCheckbox
                                        name={"selectedBrokers " + index}
                                        checked={_isRowChecked(broker.id)}
                                        label=""
                                        _onChange={() => _handleRowSelect(broker.id, broker)}
                                    />
                                </td>
                                <td className="table-link-row__link-cell" style={{verticalAlign: 'middle'}} >
                                    <Link to={url + broker.userId} >
                                        {broker.lawsysId}
                                    </Link>

                                </td>
                                <td className="table-link-row__link-cell" style={{verticalAlign: 'middle'}} >
                                    <Link to={url + broker.userId} >
                                        {broker.lawsysName}
                                    </Link>

                                </td>
                                <td className="table-link-row__link-cell" style={{verticalAlign: 'middle'}} >
                                    <Link to={url + broker.userId} >
                                        {`${broker.forename} ${broker.surname}`}
                                    </Link>

                                </td>
                                <td className="table-link-row__link-cell" style={{verticalAlign: 'middle'}} >
                                    <Link to={url + broker.userId} >
                                        {`${broker.username}`}
                                    </Link>
                                </td>
                                <td style={{verticalAlign: 'middle'}} >
                                    <CircleIcon
                                        style={{fill: broker.status ?'#94b494':'#e0666c'}}
                                        width={'12px'}
                                    />
                                    &nbsp;
                                    {broker.status ? 'Active':'Inactive'}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <Pagination
                PageShift={brokersListPageShift}
                HandleInputChange={(name, value) => changeBrokersListPage({
                    value: value
                })}
                TotalDisplayBoxes={totalPaginationBoxes}
                TotalRecords={totalRecords}
                Page={page}
                SelectedView={parseInt(viewAmount)}
                DataLength={20}
            />
        </div>
    )
};

export default Brokers;
